<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>A Year of Biblical Womanhood</title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="ctmi" id="p0011-01-0" style="margin-top: 15%;"><span><a id="pagexi"><b>Contents</b></a></span></p><a id="pagexi">
<hr style="color: #cecece; border: thick solid;"/>
<p class="cct"><span><br/><br/></span></p>
</a><p class="cct"><a id="pagexi"><span></span></a><span href="#/letter#cc0" id="c1a" title="Link target outside of Sample"><i>A Letter to Friends</i></span></p>
<p class="cct" id="p0011-02-1"><span><a href="#/chapter5#cc1" id="c1"><i>Introduction</i></a></span></p>
<p class="cct1" id="p0011-03-2"><span><a href="#/chapter7#cc2" id="c2">October: Gentleness—Girl Gone Mild</a></span></p>
<p class="cct1" id="p0011-P-1"><span><span href="#/chapter9#cc3" id="c3" title="Link target outside of Sample">November: Domesticity—Martha, Martha</span></span></p>
<p class="cct1" id="p0011-P-2"><span><span href="#/chapter11#cc4" id="c4" title="Link target outside of Sample">December: Obedience—My Husband, My Master</span></span></p>
<p class="cct1" id="p0011-P-3"><span><span href="#/chapter13#cc5" id="c5" title="Link target outside of Sample">January: Valor—Will the <i>Real</i> Proverbs 31 Woman Please Stand Up?</span></span></p>
<p class="cct1" id="p0011-P-4"><span><span href="#/chapter15#cc6" id="c6" title="Link target outside of Sample">February: Beauty—My Breasts Are Like Towers</span></span></p>
<p class="cct1" id="p0011-P-5"><span><span href="#/chapter17#cc7" id="c7" title="Link target outside of Sample">March: Modesty—Hula-Hooping with the Amish</span></span></p>
<p class="cct1" id="p0011-P-6"><span><span href="#/chapter19#cc8" id="c8" title="Link target outside of Sample">April: Purity—The Worst Time of the Month to Go Camping</span></span></p>
<p class="cct1" id="p0011-P-7"><span><span href="#/chapter21#cc9" id="c9" title="Link target outside of Sample">May: Fertility—Quivers Full of Arrows and Sippy Cups</span></span></p>
<p class="cct1" id="p0011-P-8"><span><span href="#/chapter23#cc10" id="c10" title="Link target outside of Sample">June: Submission—A Disposition to Yield</span></span></p>
<p class="cct1" id="p0011-P-9"><span><span href="#/chapter25#cc11" id="c11" title="Link target outside of Sample">July: Justice—Eat More Guinea Pig</span></span></p>
<p class="cct1" id="p0011-P-10"><span><span href="#/chapter27#cc12" id="c12" title="Link target outside of Sample">August: Silence—I Am Woman, Hear Me No More</span></span></p>
<p class="cct1" id="p0011-P-11"><span><span href="#/chapter29#cc13" id="c13" title="Link target outside of Sample">September: Grace—Days of Awe</span></span></p>
<p class="cct" id="p0011-P-12"><span><span href="#/chapter30#cc14" id="c14" title="Link target outside of Sample"><i>Acknowledgments</i></span></span></p>
<p class="cct" id="p0011-P-13"><span><span href="#/chapter31#cc15" id="c15" title="Link target outside of Sample"><i>Notes</i></span></span></p>
<p class="cct" id="p0011-P-14"><span><span href="#/chapter32#cc16" id="c16" title="Link target outside of Sample"><i>About the Author</i></span></span></p>
<p class="cct"><span><span href="#/excerpt#cc17" id="c17" title="Link target outside of Sample"><i>An excerpt from</i> Searching for Sunday</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?7fc8bc07